export const AD_LANGUAGE_OPTIONS = [
  { code: 'EN', label: 'English (EN)' },
  { code: 'ES', label: 'Spanish (ES)' },
  { code: 'FR', label: 'French (FR)' },
  { code: 'DE', label: 'German (DE)' },
  { code: 'IT', label: 'Italian (IT)' },
  { code: 'PT', label: 'Portuguese (PT)' },
  { code: 'PT-BR', label: 'Portuguese - Brazil (PT-BR)' },
  { code: 'NL', label: 'Dutch (NL)' },
  { code: 'PL', label: 'Polish (PL)' },
  { code: 'RU', label: 'Russian (RU)' },
  { code: 'JA', label: 'Japanese (JA)' },
  { code: 'KO', label: 'Korean (KO)' },
  { code: 'ZH', label: 'Chinese (ZH)' },
  { code: 'AR', label: 'Arabic (AR)' },
  { code: 'SV', label: 'Swedish (SV)' },
  { code: 'TR', label: 'Turkish (TR)' },
] as const;
